import anime from 'animejs'
import {ConnectedComponent,sharedComponent} from 'lowkey-component'

import {HoverImages} from '@components/helpers/HoverImages'
import {TextAnimation} from '@components/helpers/TextAnimation'
import {MediaQuery} from '@services/MediaQuery'
import {WindowService} from '@services/WindowService'
import {appSelectors} from '@store/appSlice'

@sharedComponent
export class NavDesktop extends ConnectedComponent {
  links: HTMLAnchorElement[] = []
  mq = MediaQuery.create()
  window = WindowService.create()
  private hoverImages: HoverImages | null = null
  private inner: HTMLDivElement | undefined = undefined
  private imageContainer: HTMLDivElement | undefined = undefined
  private images: HTMLDivElement[] = []
  private items: HTMLDivElement[] = []
  private itemsContainer: HTMLDivElement | undefined = undefined
  private textAnimations: Map<HTMLElement, TextAnimation> = new Map()

  constructor(element: HTMLDivElement) {
    super(element)
    this.resize = this.resize.bind(this)
    this.onMouseEnterLink = this.onMouseEnterLink.bind(this)
    this.onMouseLeaveLink = this.onMouseLeaveLink.bind(this)
  }

  didMount() {
    this.window.onResize.connect(this.resize)

    this.observe(appSelectors.selectIsOpenGlobalNav, (isOpen) => {
      isOpen
      ? this.open()
      : this.close()
    })


    if (this.element) {
      this.links = [
        ...this.element.querySelectorAll('.m-nav-item-desktop'),
      ] as HTMLAnchorElement[]

      this.links.map((link) => {
        const title = link.querySelector('.m-nav-item-desktop_title p') as HTMLParagraphElement
        this.textAnimations.set(title, new TextAnimation(title))
        link.addEventListener('mouseenter', this.onMouseEnterLink)
        link.addEventListener('mouseleave', this.onMouseLeaveLink)
      })
    }

    this.textAnimations.forEach((val) => {
      val.init(false)
    })

    this.inner = this.element.querySelector('.o-nav-desktop_inner') as HTMLDivElement
    this.imageContainer = this.element.querySelector('.o-nav-desktop_images') as HTMLDivElement
    this.images = [...this.element.querySelectorAll('.o-nav-desktop_image')] as HTMLDivElement[]
    this.items = [...this.element.querySelectorAll('.o-nav-desktop_item')] as HTMLDivElement[]
    this.itemsContainer = this.element.querySelector('.o-nav-desktop_items') as HTMLDivElement

    this.hoverImages = new HoverImages(
      this.itemsContainer,
      this.imageContainer,
      this.images,
      this.items,
      4.44
    )

    this.hoverImages.init()

    this.resize()
  }

  didUnmount() {
    this.hoverImages?.destroy()
    this.links.map((link) => {
      link.removeEventListener('mouseenter', this.onMouseEnterLink)
      link.removeEventListener('mouseleave', this.onMouseLeaveLink)
    })
  }

  open() {
    this.element?.classList.add('show')

    let index = 0
    this.textAnimations.forEach((val) => {
      setTimeout(() => {
        val.show()
      }, 80 * index)
      index++
    })
  }

  close() {
    this.element?.classList.remove('show')
    this.textAnimations.forEach((val) => {
      val.hide()
    })
  }

  onMouseEnterLink(event: MouseEvent) {
    const target = event.currentTarget as HTMLAnchorElement

    const hoverContent = target.querySelector('.js-hover-content') as HTMLDivElement
    if (hoverContent) {
      hoverContent.style.visibility = 'visible'
      anime({
        duration: 800,
        easing: 'easeOutCubic',
        opacity: [0, 1],
        targets: hoverContent,
      })
    }
  }

  onMouseLeaveLink(event: MouseEvent) {
    const target = event.currentTarget as HTMLAnchorElement
    const hoverContent = target.querySelector('.js-hover-content') as HTMLDivElement
    if (hoverContent) {
      hoverContent.style.visibility = 'hidden'
      anime({
        duration: 800,
        easing: 'easeOutCubic',
        opacity: [1, 0],
        targets: hoverContent,
      })
    }
  }

  resize() {
    if (this.mq.isPhone()) {
      const height = window.innerHeight
      this.element && (this.element.style.height = `${height}px`)
    } else {
      this.element && (this.element.style.height = '')
    }
  }
}
